import { setAllMeetingList, setAllMMList, setCurrentMeeting } from "stores/meeting";
import { putUpdateObjectApi } from "api/general";
import { MEETINGS } from "./constants/customConstant";


export const updateMeetingListAction = (newList) => {
    return (dispatch) => {
        dispatch(setAllMeetingList(newList));

    };
};


export const addMeetingToReduxList = (currentList, newMeeting) => {
    return [newMeeting, ...currentList];
};


export const getMeetingListFromStateByPageType = (state) => {
    const { allMeetingList, allReadMeetingList, pageType, allMMList, allUsersMeetingList } = state.meetingStore;
    switch (pageType) {
        case "1": // yk management
            return allMeetingList.filter(meeting => meeting.inst === "YK") || [];
        case "2": // yk read
            return allReadMeetingList.filter(meeting => meeting.inst === "YK") || [];
        case "3": // kurul management
            return allMeetingList.filter(meeting => meeting.inst !== "YK") || [];
        case "4": // kurul read
            return allReadMeetingList.filter(meeting => meeting.inst !== "YK") || [];
        case "attented":
            return allUsersMeetingList.filter(meeting => meeting.statFinish === 1) || [];
        case "ongoing":
            return allUsersMeetingList.filter(meeting => meeting.statFinish === 0) || [];
        default:
            return [];
    }
};



export const updateMeetingInReduxList = (currentList, updatedMeeting) => {
    if (updatedMeeting.active === 0) {
        return currentList.filter(meeting => meeting.id !== updatedMeeting.id);
    }
    return currentList.map((meeting) =>
        meeting.id === updatedMeeting.id ? updatedMeeting : meeting
    );
};


export const getUnitsFromPageType = (state, pageType) => {
    const { allAuthorizedUnits, allReadAuthorizedUnits } = state.authStore;


    let list = [];

    if (pageType === "1" || pageType === "3") { // yk
        list = allAuthorizedUnits;
    } else if (pageType === "2" || pageType === "4") {
        list = allReadAuthorizedUnits;
    }

    if (pageType === "1" || pageType === "2") { // yk
        list = list.filter(unit => unit.inst === "YK");

    } else if (pageType === "3" || pageType === "4") {
        list = list.filter(unit => unit.inst !== "YK");
    }


    return list;
}



export const updateAllMMListGeneric = (item, dispatch, allMMList) => {

    if (!allMMList) return;

    let datalist = [...allMMList];
    let tmp = datalist;
    const index = datalist.findIndex(x => x.id === item.id);
    index !== -1 ? tmp[index] = item : tmp.push({ ...item, id: Number(datalist[datalist.length - 1].id) + 1 });

    let newList = [];

    if (item.active === 0) {
        newList = datalist.filter(meeting => meeting.id !== item.id);
    } else {
        newList = datalist.map((meeting) =>
            meeting.id === item.id ? item : meeting
        );
    }
    dispatch(setAllMMList(newList));
};


export const updateMeetingAfterUserOperation = async (currentMeeting, authUser, dispatch, allMeetingList, allMMList) => {
    try {
        const { user, users, decisionCount, isThereReminder, ...meetingObj } = currentMeeting;
        meetingObj.adminUserId = authUser.id;
        const result = await putUpdateObjectApi(MEETINGS, meetingObj);
        if (result.status) {
            const updatedMeetingWithUserData = {
                ...meetingObj,
                user: authUser,
                users,
                decisionCount,
                isThereReminder
            };

            dispatch(setCurrentMeeting(updatedMeetingWithUserData));

            const newAllMeetingList = updateMeetingInReduxList(allMeetingList, updatedMeetingWithUserData);
            dispatch(setAllMeetingList(newAllMeetingList));

            updateAllMMListGeneric(updatedMeetingWithUserData, dispatch, allMMList);

            return true;
        }
    } catch (error) {
        console.error('Meeting güncelleme hatası:', error);
        return false;
    }
};



